import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * AccessGrant model representing a user's granted access to an installation (node).
 *
 * Used for multi-user / company deployments where multiple users need access
 * to the same node beyond the single-owner installation check.
 *
 * @since 1.0.0
 */
export class AccessGrant extends Model.Class<AccessGrant>("AccessGrant")({
  id: Model.Generated(Schema.String),
  personId: Schema.String,
  installationId: Schema.String,
  grantedBy: Schema.String,
  createdAt: Model.DateTimeInsertFromDate,
}) {}
